import { render, staticRenderFns } from "./not-attended.vue?vue&type=template&id=45bedef1&"
import script from "./not-attended.vue?vue&type=script&lang=js&"
export * from "./not-attended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports